{
  "seo": {
    "title": "Gazmatek — Artistenbookingbureau",
    "description": "Gazmatek vertegenwoordigt DJ's, live-acts en performers. Ontdek onze artiesten en boek uw volgende evenement.",
    "home": {
      "title": "Gazmatek — Artiestenboeking in België",
      "description": "Bookingbureau Gazmatek. DJ's, live-acts en animaties voor privé- en bedrijfsevenementen."
    },
    "artists": {
      "title": "Artiestencatalogus — Gazmatek",
      "description": "Ontdek alle artiesten vertegenwoordigd door Gazmatek."
    },
    "artistDetail": {
      "title": "{{name}} — Gazmatek",
      "description": "Bio, foto's, tarieven en beschikbaarheid van {{name}}."
    },
    "contact": {
      "title": "Contact — Gazmatek",
      "description": "Stel uw vraag aan het Gazmatek-team."
    },
    "pricing": {
      "title": "Prijssimulator — Gazmatek",
      "description": "Schat de kostprijs van uw boeking in enkele klikken."
    },
    "terms": {
      "title": "Gebruiksvoorwaarden — Gazmatek",
      "description": "De voorwaarden voor het gebruik van de website en de bookingdiensten van Gazmatek."
    },
    "privacy": {
      "title": "Privacybeleid — Gazmatek",
      "description": "Hoe Gazmatek uw persoonsgegevens verzamelt, gebruikt en beschermt."
    }
  },
  "language": {
    "switcher_aria": "Taal wijzigen"
  },
  "nav": {
    "home": "Home",
    "artists": "Artiesten",
    "pricing": "Tarieven",
    "contact": "Contact",
    "bookNow": "Boeken",
    "account": "Mijn account",
    "login": "Inloggen",
    "adminLogin": "Admin",
    "myArea": "Mijn ruimte"
  },
  "common": {
    "loading": "Laden…",
    "error": "Er is een fout opgetreden",
    "retry": "Opnieuw proberen",
    "back": "Terug",
    "all": "Alle",
    "from": "Vanaf",
    "perHour": "/ uur",
    "send": "Verzenden",
    "submit": "Verzenden",
    "required": "Verplicht veld",
    "currencyEur": "€",
    "next": "Volgende",
    "delete": "Verwijderen",
    "save": "Opslaan",
    "cancel": "Annuleren"
  },
  "home": {
    "hero": {
      "title": "Gazmatek, uw bookingbureau",
      "subtitle": "DJ's, live-acts en performers. De soundtrack op maat van uw evenement.",
      "cta": "Een artiest boeken",
      "ctaAria": "Een boekingsaanvraag starten",
      "stats": {
        "aria": "Belangrijkste cijfers van het agentschap",
        "artists": "Artiesten op de roster",
        "events": "Geproduceerde evenementen",
        "reply": "Reactietijd"
      }
    },
    "featured": {
      "title": "Uitgelichte artiesten",
      "subtitle": "Een selectie van talenten die we deze maand uitlichten.",
      "empty": "Momenteel geen uitgelichte artiesten.",
      "discoverAll": "Ontdek onze artiesten",
      "viewArtist": "Bekijk de artiest"
    },
    "services": {
      "title": "Onze diensten",
      "subtitle": "Alle formats: clubs, zalen, bruiloften, festivals.",
      "dj": {
        "title": "DJ-sets",
        "description": "Sets voor clubs, bruiloften en privéfeesten, van house tot techno."
      },
      "live": {
        "title": "Live-acts",
        "description": "Live performances, hybride of full band, voor podia en festivals."
      },
      "production": {
        "title": "Productie",
        "description": "Geluid- en lichtregie, professionele apparatuur ter beschikking."
      }
    },
    "ctaBanner": {
      "title": "Klaar om uw evenement te organiseren?",
      "subtitle": "Ons team antwoordt binnen 24 werkuren.",
      "button": "Een aanvraag starten"
    },
    "process": {
      "eyebrow": "Hoe het werkt",
      "title": "Vier stappen, geen blinde vlekken",
      "subtitle": "Van de eerste zoekopdracht tot op het podium, wij houden alles op koers.",
      "steps": {
        "discover": {
          "title": "Ontdekken",
          "desc": "Doorblader het roster, beluister de sets en check de beschikbaarheid in realtime."
        },
        "brief": {
          "title": "Aanvragen",
          "desc": "Verstuur uw aanvraag in enkele stappen: artiest, datum, locatie en opties."
        },
        "confirm": {
          "title": "Bevestigen",
          "desc": "Bevestig uw aanvraag per e-mail, betaal het voorschot en onderteken het contract online."
        },
        "deliver": {
          "title": "Leveren",
          "desc": "Coördinatie T-7, techniek ter plaatse, debrief na het evenement."
        }
      }
    },
    "ourStory": {
      "title": "Onze geschiedenis",
      "intro": "Geboren in 2010 op het Belgische Plateau is Gazmatek een zelfbestuurd collectief, gebouwd rond geluid, scenografie en opkomende artiesten. Crew, label en eigen geluidssysteem — elke euro wordt geherinvesteerd in productie, materiaal en artiesten.",
      "mission": "Onze missie is nog steeds dezelfde: opkomend talent op het podium brengen met compromisloze eisen aan geluid, scenografie en betrouwbaarheid — van het eerste contact tot de debriefing na het evenement.",
      "statYears": "Jaren actief",
      "statEvents": "Geproduceerde evenementen",
      "statArtists": "Artiesten in het roster"
    },
    "pricingGrid": {
      "eyebrow": "Publiek prijsraster",
      "title": "Geen verborgen prijzen — hier is onze formule",
      "subtitle": "Het cachet van een artiest hangt af van zijn niveau (L1 → L4) en de capaciteit van de locatie. Vermenigvuldig met de ticketprijs en u krijgt de marge.",
      "formula": {
        "cachet": "Cachet",
        "multiplier": "Multiplicator",
        "ticket": "Ticketprijs"
      },
      "col": {
        "capacity": "Capaciteit",
        "bounds": "Marge"
      },
      "example": "Voorbeeld: een L3 in een zaal van 1 000 personen bij €20 → 40 × 20 = €800 aanbevolen cachet.",
      "examples": {
        "title": "Voorbeeldcachets",
        "col": {
          "ticket": "Ticketprijs",
          "gross": "Recette",
          "floor": "Ondergrens",
          "cap": "Bovengrens"
        }
      },
      "cta": "Open de simulator"
    },
    "pricingTeaser": {
      "title": "Schat uw budget in minder dan een minuut",
      "subtitle": "Capaciteit, ticketprijs, niveau, formaat — onze simulator berekent een aanbevolen cachet in realtime.",
      "counter": "{{count}} actieve artiesten",
      "cta": "Open de simulator"
    },
    "socialProof": {
      "title": "Wat ze zeggen",
      "subtitle": "Enkele getuigenissen van organisatoren die we recent hebben begeleid."
    },
    "faq": {
      "title": "Veelgestelde vragen",
      "subtitle": "Antwoorden op de vragen die we het vaakst krijgen.",
      "q1": {
        "q": "Hoe snel krijg ik een antwoord?",
        "a": "Gemiddeld binnen 24 werkuren. Korte-termijnevenementen (< 14 dagen) krijgen voorrang."
      },
      "q2": {
        "q": "Welke regio's bedienen jullie?",
        "a": "Heel België standaard. Buurlanden (Frankrijk, Nederland, Luxemburg, Duitsland) op offerte."
      },
      "q3": {
        "q": "Hoe verloopt de betaling?",
        "a": "30 % voorschot bij bevestiging, saldo uiterlijk 48u voor het evenement."
      },
      "q4": {
        "q": "En als we moeten annuleren?",
        "a": "Voorwaarden staan in het boekingscontract: volledige terugbetaling tot 30 dagen voor, daarna degressief. We blijven flexibel bij overmacht."
      }
    },
    "partners": {
      "title": "Zij vertrouwen ons"
    }
  },
  "artists": {
    "pageTitle": "Artiestencatalogus",
    "pageSubtitle": "Filter op stijl, budget of beschikbaarheid.",
    "filters": {
      "title": "Filters",
      "genre": "Stijl",
      "date": "Beschikbaar op",
      "apply": "Toepassen",
      "reset": "Filters resetten",
      "anyGenre": "Alle stijlen"
    },
    "emptyTitle": "Geen artiest voldoet aan uw zoekopdracht",
    "emptyText": "Probeer uw criteria te verbreden of reset de filters.",
    "card": {
      "from": "Vanaf",
      "perHour": "/ uur",
      "view": "Bekijk profiel",
      "tierLabel": "Prijsklasse",
      "setType": {
        "dj": "DJ",
        "live": "Live",
        "hybrid": "Hybride"
      }
    }
  },
  "artistDetail": {
    "notFoundTitle": "Artiest niet gevonden",
    "notFoundText": "Deze pagina bestaat niet meer of is niet gepubliceerd.",
    "backToCatalog": "Terug naar catalogus",
    "bio": "Biografie",
    "gallery": "Galerij",
    "availability": "Beschikbaarheid",
    "availabilityComingSoon": "Interactieve kalender binnenkort beschikbaar.",
    "priceCard": {
      "title": "Tarieven",
      "tier": "Prijscategorie",
      "hint": "De uiteindelijke prijs hangt af van uw evenement (capaciteit, ticketprijs, formaat). Start de simulator voor een gedetailleerde schatting.",
      "cta": "Deze artiest boeken",
      "estimate": "Mijn budget schatten",
      "hourlyRate": "Uurtarief",
      "travel": "Reiskosten",
      "perKm": "/ km"
    },
    "services": "Aangeboden diensten"
  },
  "pricing": {
    "title": "Prijssimulator",
    "subtitle": "Indicatieve schatting, niet-contractueel.",
    "form": {
      "artist": "Artiest",
      "selectArtist": "Selecteer een artiest",
      "duration": "Duur (uren)",
      "date": "Datum",
      "location": "Adres / Postcode",
      "options": "Opties",
      "estimate": "Schatten",
      "bookNow": "Nu boeken",
      "capacity": "Capaciteit",
      "ticketPrice": "Ticketprijs (€)",
      "level": "Artiestniveau",
      "setType": "Type set",
      "setTypeDj": "DJ",
      "setTypeHybrid": "Hybride",
      "setTypeLive": "Live"
    },
    "result": {
      "title": "Schatting",
      "artistCost": "Cachet artiest",
      "travelCost": "Reiskosten",
      "optionsCost": "Opties",
      "subtotal": "Subtotaal excl. btw",
      "vat": "Btw (21%)",
      "total": "Totaal incl. btw",
      "disclaimer": "Niet-contractuele schatting. De definitieve prijs wordt bevestigd na bestudering van uw aanvraag.",
      "bookCta": "Boeken met deze schatting",
      "outOfZone": "Deze zone wordt niet bediend. Neem contact met ons op voor een persoonlijke studie.",
      "artistFeeTitle": "Aanbevolen cachet (ticketed event)",
      "artistFeeRecommended": "Aanbevolen cachet",
      "artistFeeRange": "Bandbreedte",
      "artistFeeGrossShare": "Oftewel {{percent}} van de bruto-opbrengst"
    },
    "errors": {
      "invalidAddress": "Ongeldig adres. Controleer postcode of adres.",
      "missingFields": "Vul alle verplichte velden in.",
      "artistNotFound": "Artiest niet gevonden, de selectie werd gereset."
    },
    "calendarPreview": {
      "title": "Beschikbaarheid van de artiest",
      "clickHint": "Klik op een vrije dag om de datum vooraf in te vullen."
    }
  },
  "contact": {
    "title": "Contact",
    "subtitle": "Stel uw vraag, wij antwoorden binnen 24 werkuren.",
    "form": {
      "name": "Volledige naam",
      "email": "E-mail",
      "subject": "Onderwerp",
      "message": "Uw bericht",
      "submit": "Bericht verzenden",
      "success": "Bericht verzonden. Bedankt!",
      "error": "Uw bericht kon op dit moment niet worden verzonden.",
      "namePlaceholder": "bv. Marie Dupont",
      "emailPlaceholder": "u@voorbeeld.com",
      "subjectPlaceholder": "bv. Offerteaanvraag voor een huwelijk",
      "messagePlaceholder": "Beschrijf uw evenement: datum, locatie, gewenste sfeer…"
    },
    "errors": {
      "nameRequired": "Naam is verplicht.",
      "emailRequired": "E-mail is verplicht.",
      "emailInvalid": "Ongeldige e-mail.",
      "subjectRequired": "Onderwerp is verplicht.",
      "messageRequired": "Bericht is verplicht.",
      "messageTooShort": "Uw bericht moet minstens 20 tekens bevatten."
    },
    "coordinates": {
      "title": "Contactgegevens",
      "email": "E-mail",
      "phone": "Telefoon",
      "address": "Adres"
    },
    "dropdownPlaceholder": "Onderwerp*"
  },
  "bookingCta": {
    "primary": "Een artiest boeken",
    "primaryAria": "Een boekingsaanvraag starten",
    "withArtist": "{{name}} boeken",
    "withArtistAria": "Aanvraag voor {{name}} starten",
    "sticky": "Boeken"
  },
  "bookingNew": {
    "title": "Een artiest boeken",
    "subtitle": "Vul uw evenementgegevens in en ontvang direct een offerte.",
    "disclaimer": "Na verzending ontvangt u een e-mail om uw boeking te bevestigen. Het Gazmatek-team valideert vervolgens uw aanvraag binnen 24 werkuren.",
    "authRequired": {
      "title": "Inloggen vereist",
      "description": "Maak eerst een account aan of log in om een boeking aan te vragen en je bookings op te volgen.",
      "signup": "Account aanmaken",
      "login": "Ik heb al een account"
    },
    "artist": {
      "title": "U wenst te boeken",
      "name": "Artiest",
      "genre": "Genre",
      "tier": "Prijscategorie",
      "notFound": "Deze artiest is momenteel niet boekbaar.",
      "missingId": "Kies een artiest vanaf zijn profielpagina om een boeking te starten."
    },
    "fields": {
      "date": "Datum en tijd van het evenement",
      "duration": "Duur (uren)",
      "street": "Straat en nummer",
      "postalCode": "Postcode",
      "city": "Stad",
      "country": "Land",
      "capacity": "Capaciteit (aantal plaatsen)",
      "ticketPrice": "Ticketprijs (€)",
      "setType": "Setformaat",
      "setType_dj": "DJ-set",
      "setType_hybrid": "Hybride (DJ + instrumenten)",
      "setType_live": "Live-set",
      "context": "Details over het evenement (optioneel)"
    },
    "errors": {
      "dateRequired": "Datum is verplicht.",
      "durationRequired": "Geldige duur is verplicht.",
      "streetRequired": "Straat is verplicht.",
      "postalCodeRequired": "Postcode is verplicht.",
      "cityRequired": "Stad is verplicht.",
      "countryRequired": "Land is verplicht.",
      "contextTooShort": "Details zijn te kort.",
      "contextTooLong": "Details zijn te lang.",
      "artistRequired": "Geen artiest geselecteerd.",
      "pricingRequired": "Capaciteit en ticketprijs zijn vereist om de offerte te berekenen.",
      "leadTime": "De datum moet minstens {{hours}} uur in de toekomst liggen.",
      "artistUnavailable": "De artiest is niet beschikbaar op deze datum. Kies een ander tijdslot."
    },
    "form": {
      "submit": "Aanvraag verzenden",
      "success": "Aanvraag verzonden — we nemen snel contact met u op.",
      "successTitle": "Aanvraag ontvangen",
      "successBody": "Bedankt! Een teamlid van Gazmatek neemt binnen 24 werkuren contact met u op om de beschikbaarheid te bevestigen en de betaling te regelen. Een samenvatting is naar uw e-mail gestuurd."
    },
    "quote": {
      "title": "Schatting",
      "artistCost": "Artiestvergoeding",
      "travelCost": "Reiskosten",
      "subtotal": "Subtotaal",
      "vat": "BTW",
      "total": "Geschat totaal",
      "disclaimer": "Indicatieve schatting — het uiteindelijke bedrag wordt na validatie bevestigd.",
      "computing": "Offerte berekenen…"
    },
    "calendarPreview": {
      "title": "Beschikbaarheid van de artiest",
      "clickHint": "Klik op een vrije dag om de datum vooraf in te vullen."
    }
  },
  "footer": {
    "rights": "© {{year}} Gazmatek. Alle rechten voorbehouden.",
    "tagline": "Artiestenboeking — België",
    "legal": {
      "terms": "Gebruiksvoorwaarden",
      "privacy": "Privacybeleid"
    }
  },
  "cookieConsent": {
    "aria_label": "Cookie-toestemming",
    "title": "Uw privacy telt",
    "description": "Wij gebruiken cookies om de werking, het gebruik en de ervaring te garanderen. U beslist wat u toestaat.",
    "customize": "Aanpassen",
    "accept_all": "Alles aanvaarden",
    "reject_all": "Alles weigeren",
    "save": "Mijn keuzes opslaan",
    "category_necessary": "Strikt noodzakelijk",
    "category_necessary_desc": "Onmisbaar voor veiligheid en basisfunctionaliteit.",
    "category_necessary_badge": "Altijd actief",
    "category_analytics": "Analytics",
    "category_analytics_desc": "Helpen ons te begrijpen hoe de site wordt gebruikt.",
    "category_marketing": "Marketing",
    "category_marketing_desc": "Voor inhoudpersonalisatie en campagnemeting.",
    "reopen_aria": "Cookievoorkeuren"
  },
  "notFound": {
    "title": "Pagina niet gevonden",
    "text": "De pagina die u zoekt bestaat niet of werd verplaatst.",
    "back": "Terug naar de homepage"
  },
  "availability": {
    "free": "Beschikbaar",
    "partial": "Gedeeltelijk beschikbaar",
    "unavailable": "Onbeschikbaar"
  },
  "booking": {
    "title": "Boekingsaanvraag",
    "subtitle": "Enkele stappen om uw evenement te bevestigen.",
    "steps": {
      "artist": "Artiest",
      "datetime": "Datum",
      "location": "Locatie",
      "client": "Contact",
      "summary": "Samenvatting"
    },
    "fields": {
      "artist": "Artiest",
      "date": "Datum",
      "time": "Uur",
      "duration": "Duur (u)",
      "location": "Locatie / Adres",
      "context": "Context",
      "contextPlaceholder": "Type evenement, sfeer, beperkingen…",
      "clientName": "Naam",
      "clientEmail": "E-mail",
      "clientPhone": "Telefoon"
    },
    "summary": {
      "title": "Samenvatting",
      "disclaimer": "Niet-contractuele schatting. Definitieve prijs na studie.",
      "submit": "Aanvraag verzenden"
    },
    "errors": {
      "missingFields": "Vul de verplichte velden in."
    },
    "sent": {
      "title": "Aanvraag verzonden",
      "body": "Een samenvatting is verzonden naar"
    },
    "status": {
      "pending_validation": "Wacht op validatie",
      "awaiting_deposit": "Wacht op voorschot",
      "confirmed": "Bevestigd",
      "completed": "Afgerond",
      "cancelled": "Geannuleerd",
      "rejected": "Geweigerd"
    }
  },
  "auth": {
    "password": "Wachtwoord",
    "signIn": "Aanmelden",
    "signOut": "Afmelden",
    "invalidCredentials": "Ongeldige inloggegevens",
    "artist": {
      "title": "Artiest aanmelden"
    },
    "admin": {
      "title": "Admin aanmelden"
    },
    "sessionExpired": "Uw sessie is verlopen, log opnieuw in."
  },
  "artistArea": {
    "nav": {
      "calendar": "Mijn agenda",
      "allBookings": "Al mijn boekingen",
      "profile": "Mijn profiel",
      "onboarding": "Onboarding voltooien"
    },
    "dashboard": {
      "title": "Mijn ruimte",
      "welcome": "Welkom {{name}}"
    },
    "upcoming": {
      "title": "Komende boekingen",
      "empty": "Geen komende boekingen."
    },
    "bookings": {
      "title": "Mijn boekingen",
      "upcoming": "Komend",
      "past": "Voorbij"
    },
    "bookingDetail": {
      "title": "Boeking detail",
      "eyebrow": "Artiestenboeking",
      "heroTitle": "Optreden op {{date}}",
      "back": "Terug naar boekingen",
      "status": "Status",
      "reference": "Interne referentie",
      "eventSection": "Eventgegevens",
      "pricingSection": "Tarifering",
      "clientSection": "Klant",
      "statusSection": "Boekingsstatus",
      "durationValue": "{{hours}} u",
      "total": "Geoffreerd totaal",
      "deposit": "Voorschot",
      "remaining": "Resterend saldo",
      "cancelReason": "Reden van annulering",
      "clientLabel": "Contactpersoon",
      "clientHiddenTitle": "Contact verborgen",
      "clientHidden": "Klantgegevens worden zichtbaar zodra de aanbetaling is bevestigd."
    },
    "calendar": {
      "title": "Mijn agenda",
      "add": "Onbeschikbaarheid toevoegen",
      "startsAt": "Start",
      "endsAt": "Eind",
      "type": "Type",
      "personal": "Persoonlijk",
      "externalGig": "Externe gig",
      "eventTitle": "Titel van het evenement",
      "notes": "Privé notities",
      "list": "Mijn onbeschikbaarheden",
      "empty": "Geen onbeschikbaarheid.",
      "created": "Onbeschikbaarheid aangemaakt",
      "deleteTitle": "Onbeschikbaarheid verwijderen",
      "deleteConfirm": "De onbeschikbaarheid van {{start}} tot {{end}} verwijderen?"
    },
    "col": {
      "location": "Locatie",
      "client": "Klant"
    },
    "onboarding": {
      "bannerMessage": "Uw engagementcontract is nog niet ondertekend. Voltooi uw onboarding om in de roster te verschijnen.",
      "bannerCta": "Onboarding voltooien"
    }
  },
  "admin": {
    "dashboard": {
      "title": "Admin dashboard",
      "welcome": "Welkom {{name}}"
    },
    "nav": {
      "artists": "Artiesten",
      "bookings": "Boekingen",
      "content": "Inhoud",
      "settings": "Instellingen"
    },
    "artists": {
      "title": "Artistenbeheer",
      "create": "Artiest aanmaken",
      "list": "Catalogus",
      "created": "Artiest aangemaakt",
      "deleteConfirm": "Deze artiest verwijderen?",
      "publish": "Publiceren",
      "unpublish": "Depubliceren",
      "published": "Gepubliceerd",
      "featured": "Uitgelicht",
      "invitations": {
        "title": "Artiestuitnodigingen",
        "subtitle": "Stuur een magic link zodat een nieuwe artiest het roster kan vervoegen.",
        "create": "Een nieuwe artiest uitnodigen",
        "list": "Verzonden uitnodigingen",
        "createCta": "Uitnodiging versturen",
        "createdToast": "Uitnodiging verzonden naar {{email}}",
        "createdTitle": "Uitnodiging verzonden",
        "createdHint": "Kopieer onderstaande link als de artiest de e-mail niet ontvangt:",
        "linkCopied": "Link gekopieerd",
        "copyLink": "Link kopiëren",
        "resendCta": "Opnieuw verzenden",
        "resendTitle": "Uitnodiging opnieuw verzenden",
        "resendConfirm": "Een nieuwe link sturen naar {{email}}? De oude link wordt ongeldig.",
        "resentToast": "Nieuwe link verzonden naar {{email}}",
        "revokeCta": "Intrekken",
        "revokeTitle": "Uitnodiging intrekken",
        "revokeConfirm": "De artiest kan de link niet meer gebruiken. Doorgaan?",
        "revokedToast": "Uitnodiging ingetrokken",
        "empty": "Nog geen uitnodigingen.",
        "filterStatus": "Filter op status",
        "filterStatusAll": "Alle statussen",
        "status": {
          "pending": "In afwachting",
          "accepted": "Geaccepteerd",
          "expired": "Verlopen",
          "revoked": "Ingetrokken"
        },
        "setType": {
          "dj": "DJ",
          "hybrid": "Hybride",
          "live": "Live"
        },
        "fields": {
          "email": "E-mail van de artiest",
          "stageName": "Artiestennaam",
          "level": "Niveau (tier)",
          "setType": "Hoofdformat",
          "customMessage": "Persoonlijke boodschap (optioneel)"
        },
        "col": {
          "email": "E-mail",
          "stageName": "Artiestennaam",
          "level": "Niveau",
          "status": "Status",
          "expiresAt": "Verloopt op",
          "resendCount": "Heropgestuurd",
          "actions": "Acties"
        },
        "generateLink": "Nieuwe link genereren",
        "generateLinkTitle": "Een nieuwe uitnodigingslink genereren",
        "generateLinkConfirm": "Dit genereert een nieuwe link en maakt alle eerder gedeelde links ongeldig. De nieuwe link wordt naar uw klembord gekopieerd.",
        "generateLinkCta": "Genereren en kopiëren"
      },
      "edit": "Artiest bewerken",
      "saved": "Artiest opgeslagen",
      "searchLabel": "Zoeken",
      "searchPlaceholder": "Artiestennaam of slug…",
      "form": {
        "slug": "Slug",
        "stageName": "Artiestennaam",
        "genre": "Stijl",
        "bioFr": "Bio FR",
        "bioNl": "Bio NL",
        "bioEn": "Bio EN",
        "coverImageUrl": "URL omslagafbeelding",
        "level": "Niveau (Gazmatek-tier)",
        "levelHint": "Het cachet wordt berekend via het Gazmatek-raster: vermenigvuldiger (volgens niveau + capaciteit) × ticketprijs. Een Live of Hybrid voegt een coëfficiënt toe (+10%/+15%)."
      },
      "sections": {
        "identity": "Identiteit",
        "bios": "Biografieën",
        "pricing": "Interne tarifering",
        "flags": "Publicatie"
      },
      "contract": {
        "download": "Contract downloaden",
        "downloadFailed": "Kan het contract niet downloaden.",
        "reset": "Contract opnieuw genereren",
        "resetCta": "Ja, opnieuw genereren",
        "resetTitle": "Het engagementcontract opnieuw genereren",
        "resetConfirm": "Weet u het zeker? Het huidige engagementcontract van {{name}} wordt verwijderd en bij de volgende klik op Ondertekenen wordt een nieuw concept aangemaakt.",
        "resetDone": "Contract opnieuw gegenereerd — de artiest moet opnieuw ondertekenen.",
        "resetFailed": "Opnieuw genereren van het contract is mislukt."
      },
      "deleteTitle": "Artiest verwijderen",
      "deleteConfirmBody": "{{name}} definitief verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
      "deleted": "Artiest verwijderd",
      "deleteFailed": "Verwijderen van de artiest mislukt."
    },
    "bookings": {
      "title": "Boekingsaanvragen",
      "filterStatus": "Filter op status",
      "empty": "Geen aanvraag.",
      "approve": "Goedkeuren",
      "reject": "Afwijzen",
      "approved": "Boeking goedgekeurd",
      "rejected": "Boeking afgewezen",
      "rejectModalTitle": "Boeking afwijzen",
      "rejectReasonOptional": "Reden van afwijzing (optioneel)",
      "rejectReasonPlaceholder": "Leg de reden van de afwijzing uit…",
      "rejectConfirm": "Afwijzing bevestigen",
      "markDepositPaid": "Voorschot ontvangen",
      "markDepositPaidConfirm": "Bevestigen dat het voorschot ontvangen is?",
      "markDepositPaidSuccess": "Voorschot gemarkeerd als betaald",
      "markCompleted": "Saldo betaald / afsluiten",
      "markCompletedConfirm": "Deze boeking markeren als volledig betaald en afgesloten?",
      "markCompletedSuccess": "Boeking afgesloten",
      "detail": {
        "title": "Boekingsdetails",
        "back": "Terug naar lijst",
        "eyebrow": "Boeking",
        "heroTitle": "{{artist}}",
        "clientSection": "Klantgegevens",
        "eventSection": "Evenement",
        "pricingSection": "Tarifering",
        "statusSection": "Status & historiek",
        "actionsSection": "Admin-acties",
        "artist": "Artiest",
        "locale": "Taal",
        "inviteHint": "Deze klant heeft zijn account nog niet geactiveerd. Stuur een e-mail zodat hij een wachtwoord kan instellen.",
        "inviteButton": "Uitnodigingsmail versturen",
        "inviteSent": "Uitnodigingsmail verstuurd",
        "alreadyClaimed": "Deze klant heeft zijn account al geactiveerd.",
        "status": "Status",
        "submittedAt": "Aanvraag ontvangen op",
        "approvedAt": "Goedgekeurd op",
        "paidAt": "Volledig betaald op",
        "reference": "Referentie",
        "durationValue": "{{hours}} u",
        "total": "Totaal incl. btw",
        "deposit": "Voorschot",
        "remaining": "Resterend saldo",
        "cancelReason": "Reden van annulering",
        "noActions": "Geen actie beschikbaar voor deze status."
      },
      "calendarPreview": {
        "title": "Agenda van de artiest",
        "hint": "Selecteer eerst een artiest om de bezette periodes te zien.",
        "clickHint": "Klik op een vrije dag om de datum vooraf in te vullen."
      },
      "edit": {
        "title": "Boeking bewerken",
        "saved": "Boeking bijgewerkt",
        "errorMissingDate": "Vul de datum van het evenement in"
      },
      "manualCreate": "Een handmatige boeking aanmaken",
      "manualCreated": "Boeking aangemaakt",
      "col": {
        "artist": "Artiest",
        "client": "Klant",
        "date": "Datum evenement",
        "status": "Status",
        "total": "Totaal"
      },
      "sections": {
        "artist": "Artiest",
        "client": "Klantgegevens",
        "event": "Evenement",
        "adminControls": "Agentschapsbeheer"
      },
      "fields": {
        "capacity": "Capaciteit (plaatsen)",
        "ticketPrice": "Ticketprijs (€)",
        "setType": "Setformaat",
        "quotedTotalCents": "Totaal offerte (centen)",
        "depositCents": "Voorschot (centen)",
        "quotedTotalEuros": "Totaal offerte",
        "depositEuros": "Voorschot",
        "initialStatus": "Beginstatus",
        "skipEmails": "Geen e-mails versturen",
        "overrideConflict": "Forceren ondanks agendaconflict",
        "internalNote": "Interne notitie"
      },
      "noEmailWarning": "Zonder e-mail maakt deze boeking een klant aan die zijn account niet kan activeren."
    },
    "content": {
      "title": "Editorial inhoud",
      "empty": "Geen blok.",
      "saved": "Blok {{key}} bijgewerkt"
    },
    "settings": {
      "title": "Agentschapsinstellingen",
      "signature": {
        "title": "Handtekening van de manager",
        "copy": "Deze handtekening wordt automatisch toegevoegd aan engagementcontracten voordat ze naar de artiest worden gestuurd. Ze verschijnt in de kolom „For the Agency”.",
        "loading": "Laden…",
        "empty": "Nog geen handtekening opgeslagen — contracten worden verstuurd zonder agentschap-handtekening.",
        "previewAlt": "Voorbeeld van de handtekening",
        "create": "Mijn handtekening aanmaken",
        "replace": "Handtekening vervangen",
        "remove": "Verwijderen",
        "save": "Opslaan",
        "hint": "Teken je handtekening met muis of vinger.",
        "saved": "Handtekening opgeslagen",
        "saveFailed": "Opslaan van de handtekening mislukt",
        "removed": "Handtekening verwijderd"
      },
      "companyInfo": {
        "title": "Bedrijfsinformatie",
        "copy": "Deze waarden worden vooringevuld in het blok „THE AGENCY” van elk engagementcontract dat naar artiesten wordt verstuurd.",
        "save": "Opslaan",
        "saved": "Bedrijfsinformatie opgeslagen",
        "saveFailed": "Opslaan van de bedrijfsinformatie mislukt",
        "fields": {
          "name": "Bedrijfsnaam",
          "representative": "Vertegenwoordiger",
          "address": "Adres",
          "companyNumber": "Ondernemingsnummer (KBO/BCE)",
          "vatNumber": "BTW-nummer",
          "email": "Contactmail",
          "iban": "IBAN",
          "city": "Stad (plaats van ondertekening)"
        }
      }
    },
    "list": {
      "truncationWarning": "{{shown}} van {{total}} weergegeven. Verfijn uw zoekopdracht om de rest te zien."
    }
  },
  "account": {
    "login": {
      "title": "Inloggen",
      "forgotLink": "Wachtwoord vergeten?",
      "signupLink": "Account aanmaken"
    },
    "signup": {
      "title": "Account aanmaken",
      "hint": "Maak je klantruimte aan om je bookings te volgen en meerdere artiesten voor één avond te boeken.",
      "accountType": {
        "label": "Ik ben",
        "individual": "Particulier",
        "company": "Bedrijf"
      },
      "displayName": "Volledige naam",
      "confirmPassword": "Wachtwoord bevestigen",
      "phone": "Telefoon",
      "companyHint": "Als je voor een bedrijf boekt, vul deze gegevens in voor de facturatie. Laat anders leeg.",
      "companyName": "Bedrijfsnaam",
      "companyNumber": "Ondernemingsnummer (KBO)",
      "vatNumber": "Btw-nummer",
      "addressStreet": "Straat",
      "addressNumber": "Nummer",
      "addressZip": "Postcode",
      "addressCity": "Stad",
      "addressCountry": "Land",
      "next": "Volgende",
      "back": "Terug",
      "submit": "Mijn account aanmaken",
      "loginLink": "Ik heb al een account",
      "failed": "Aanmaak mislukt. Dit e-mailadres is mogelijk al in gebruik.",
      "success": "Account aangemaakt",
      "steps": {
        "account": "Account",
        "company": "Bedrijf",
        "address": "Adres"
      },
      "placeholders": {
        "displayName": "Jan Janssen",
        "email": "uw@email.com",
        "password": "Minimaal 8 tekens",
        "confirmPassword": "Wachtwoord opnieuw invoeren",
        "companyName": "Mijn bedrijf BV",
        "addressStreet": "Louizalaan",
        "addressNumber": "42",
        "addressCity": "Brussel",
        "phone": "+32 470 12 34 56"
      },
      "errors": {
        "displayNameRequired": "Naam is verplicht.",
        "emailRequired": "E-mail is verplicht.",
        "emailInvalid": "Ongeldig e-mailadres.",
        "passwordTooShort": "Wachtwoord moet minstens {{min}} tekens bevatten.",
        "passwordMismatch": "Wachtwoorden komen niet overeen.",
        "addressStreetRequired": "Straat is verplicht.",
        "addressNumberRequired": "Nummer is verplicht.",
        "addressZipRequired": "Postcode is verplicht.",
        "addressCityRequired": "Stad is verplicht.",
        "addressCountryRequired": "Land is verplicht.",
        "phoneRequired": "Telefoon is verplicht."
      }
    },
    "forgot": {
      "title": "Wachtwoord vergeten",
      "hint": "Voer je e-mailadres in. Als er een account bestaat sturen we een link om je wachtwoord opnieuw in te stellen.",
      "submit": "Link versturen",
      "sent": "Als er een account bestaat voor dit e-mailadres is er een reset-link verstuurd.",
      "loginLink": "Terug naar inloggen"
    },
    "reset": {
      "title": "Nieuw wachtwoord",
      "hint": "Kies een nieuw wachtwoord voor je account.",
      "submit": "Bijwerken",
      "missingToken": "Ongeldige of verlopen link.",
      "success": "Wachtwoord bijgewerkt"
    },
    "claim": {
      "title": "Welkom! Activeer je account",
      "hint": "Kies een wachtwoord om je klantruimte af te ronden.",
      "submit": "Mijn account activeren",
      "missingToken": "Ongeldige of verlopen link.",
      "success": "Account geactiveerd. Je kan nu inloggen."
    },
    "dashboard": {
      "title": "Mijn account",
      "welcome": "Welkom {{name}}",
      "upcoming": "Komende bookings",
      "allBookings": "Al mijn bookings"
    },
    "bookings": {
      "title": "Mijn bookings",
      "tabs": {
        "upcoming": "Komend",
        "past": "Voorbij",
        "cancelled": "Geannuleerd",
        "all": "Alle"
      },
      "cancel": {
        "action": "Annuleren",
        "modalTitle": "Deze boeking annuleren?",
        "reasonLabel": "Reden (optioneel)",
        "reasonPlaceholder": "Vertel ons kort waarom je annuleert…",
        "confirm": "Annulering bevestigen",
        "success": "Boeking geannuleerd"
      },
      "loadError": "Kan uw boekingen niet laden. Probeer opnieuw.",
      "edit": {
        "title": "Boeking bewerken",
        "saved": "Boeking bijgewerkt",
        "errorMissingDate": "Geef de datum van het evenement op"
      }
    }
  },
  "onboarding": {
    "title": "Engagementcontract",
    "statusTitle": "Status van het contract",
    "statusPending": "Je engagementcontract moet ondertekend worden om je account te activeren.",
    "statusAwaitingSignature": "Je contract wacht op ondertekening in Documenso. Hervat de ondertekening om het af te ronden.",
    "statusSigned": "Contract ondertekend op {{date}}.",
    "contractPreview": "Voorbeeld van het contract",
    "contractPreviewBody": "Lees de voorwaarden hieronder zorgvuldig door, vink het vakje aan en onderteken.",
    "providerNote": "De elektronische ondertekening verloopt via Documenso. Vink de bevestiging aan en klik op Ondertekenen — er opent een nieuw tabblad met je contract.",
    "waitingForWebhook": "Wachten op de bevestiging van de ondertekening… Deze pagina wordt automatisch bijgewerkt.",
    "downloadDraft": "Concept-PDF downloaden",
    "downloadSigned": "Ondertekende PDF downloaden",
    "acceptTerms": "Ik heb de voorwaarden van het engagementcontract gelezen en aanvaard.",
    "sign": "Ondertekenen via Documenso",
    "resumeSigning": "Ondertekening hervatten",
    "signed": "Contract succesvol ondertekend",
    "infoTitle": "Jouw gegevens",
    "infoBody": "Deze gegevens komen op je contract te staan. Vul ze in en sla op vóór de ondertekening.",
    "infoSaved": "Gegevens opgeslagen",
    "infoIncomplete": "Vul je volledige naam, telefoon, adres en land in vóór je ondertekent.",
    "fields": {
      "fullName": "Volledige naam",
      "phone": "Telefoon",
      "address": "Adres",
      "country": "Land",
      "vatNumber": "Btw-nummer",
      "companyNumber": "Ondernemingsnummer (KBO/BCE)"
    },
    "errors": {
      "mustAccept": "Je moet de voorwaarden aanvaarden voor je kan ondertekenen.",
      "noSigningUrl": "De Documenso-handtekeninglink kan niet worden opgehaald. Probeer opnieuw.",
      "saveFailed": "Opslaan van je gegevens is mislukt."
    }
  },
  "artistProfile": {
    "title": "Mijn profiel",
    "saved": "Wijzigingen opgeslagen",
    "coverHint": "Geen foto opgeslagen. Upload een bestand of plak hieronder een URL.",
    "uploadSuccess": "Omslagfoto bijgewerkt",
    "changePassword": "Mijn wachtwoord wijzigen",
    "passwordChanged": "Wachtwoord bijgewerkt",
    "sections": {
      "identity": "Identiteit (beheerd door het agentschap)",
      "personal": "Persoonlijke info",
      "password": "Wachtwoord",
      "contract": "Engagementcontract",
      "cover": "Omslagfoto",
      "bios": "Biografieën",
      "technical": "Technische info",
      "social": "Sociale links"
    },
    "contract": {
      "statusPending": "Uw engagementcontract is nog niet ondertekend.",
      "statusAwaitingSignature": "Uw contract wacht op ondertekening in Documenso. Hervat het ondertekenen om af te ronden.",
      "statusSigned": "Contract ondertekend op {{date}}.",
      "providerNote": "De elektronische handtekening verloopt via Documenso. Vink de aanvaarding aan en klik op Ondertekenen — een nieuw tabblad opent met uw contract.",
      "waitingForWebhook": "Wachten op bevestiging van de handtekening… Dit gedeelte wordt automatisch bijgewerkt.",
      "downloadDraft": "Concept downloaden (PDF)",
      "downloadSigned": "Ondertekend contract downloaden (PDF)",
      "acceptTerms": "Ik heb de voorwaarden van het engagementcontract gelezen en aanvaard ze.",
      "sign": "Ondertekenen via Documenso",
      "resumeSigning": "Ondertekenen hervatten",
      "signed": "Contract succesvol ondertekend",
      "errors": {
        "mustAccept": "U moet de voorwaarden aanvaarden voordat u ondertekent.",
        "noSigningUrl": "Kan de Documenso-ondertekenlink niet ophalen. Probeer opnieuw."
      }
    },
    "fields": {
      "stageName": "Artiestennaam",
      "slug": "URL-slug",
      "fullName": "Volledige naam",
      "phone": "Telefoon",
      "address": "Adres",
      "country": "Land",
      "vatNumber": "Btw-nummer",
      "companyNumber": "Ondernemingsnummer (KBO/BCE)",
      "currentPassword": "Huidig wachtwoord",
      "newPassword": "Nieuw wachtwoord (min. {{min}} tekens)",
      "confirmPassword": "Bevestig het nieuwe wachtwoord",
      "coverImageUrl": "Afbeeldings-URL",
      "coverUpload": "Een nieuwe foto uploaden (JPG/PNG/WebP, max. 5 MB)",
      "bioFr": "Bio FR",
      "bioNl": "Bio NL",
      "bioEn": "Bio EN",
      "technicalFr": "Technische info FR",
      "technicalNl": "Technische info NL",
      "technicalEn": "Technische info EN",
      "social": {
        "instagram": "Instagram",
        "soundcloud": "SoundCloud",
        "spotify": "Spotify",
        "youtube": "YouTube",
        "tiktok": "TikTok",
        "facebook": "Facebook",
        "bandcamp": "Bandcamp",
        "website": "Website"
      }
    },
    "errors": {
      "fileTooLarge": "Afbeelding te groot (max. 5 MB).",
      "uploadFailed": "Uploaden mislukt. Probeer opnieuw.",
      "passwordTooShort": "Het nieuwe wachtwoord moet minstens {{min}} tekens bevatten.",
      "passwordMismatch": "De twee wachtwoorden komen niet overeen.",
      "passwordChangeFailed": "Wachtwoord wijzigen mislukt. Controleer uw huidige wachtwoord."
    }
  },
  "invitation": {
    "title": "Artiestenuitnodiging",
    "errorsTitle": "Uitnodiging niet beschikbaar",
    "welcome": "Welkom bij Gazmatek, {{name}}",
    "intro": "U bent uitgenodigd om met het adres {{email}} bij onze roster te komen. Kies een wachtwoord om uw registratie af te ronden.",
    "submit": "Doorgaan",
    "fields": {
      "password": "Wachtwoord (min. {{min}} tekens)",
      "confirmPassword": "Wachtwoord bevestigen",
      "cgu": "Ik aanvaard de gebruiksvoorwaarden",
      "privacy": "Ik aanvaard het privacybeleid"
    },
    "errors": {
      "missingToken": "Uitnodigingslink ontbreekt.",
      "invalid": "Deze uitnodiging is verlopen of niet langer geldig.",
      "passwordTooShort": "Het wachtwoord moet minstens {{min}} tekens bevatten.",
      "passwordMismatch": "De wachtwoorden komen niet overeen.",
      "acceptRequired": "Aanvaard de gebruiksvoorwaarden en het privacybeleid."
    }
  },
  "legal": {
    "lastUpdated": "Laatst bijgewerkt: 29 mei 2026",
    "terms": {
      "title": "Gebruiksvoorwaarden",
      "intro": "Deze gebruiksvoorwaarden regelen uw toegang tot en gebruik van de website van Gazmatek en de online bookingdiensten. Door op de website te surfen of een reserveringsaanvraag te versturen, aanvaardt u eraan gebonden te zijn.",
      "sections": [
        {
          "title": "1. Doel",
          "paragraphs": [
            "Gazmatek is een artiestenbookingagentschap dat dj's, liveacts en performers vertegenwoordigt en hen in contact brengt met organisatoren van evenementen in België en de buurlanden.",
            "Via de website kunt u onze roster ontdekken, een budget inschatten met de prijssimulator en een reserveringsaanvraag versturen. Het versturen van een aanvraag is geen bevestigde reservering: elke aanvraag wordt door ons team bestudeerd en bevestigd voordat een contract in werking treedt."
          ]
        },
        {
          "title": "2. Reserveringen en offertes",
          "paragraphs": [
            "De door de simulator getoonde prijzen zijn indicatief en niet contractueel. Het uiteindelijke cachet hangt af van de artiest, de datum, de capaciteit van de locatie, de ticketprijs en het gevraagde formaat; het wordt schriftelijk bevestigd nadat ons team uw aanvraag heeft bestudeerd.",
            "Een reservering is pas definitief na ontvangst van een schriftelijke bevestiging, betaling van het overeengekomen voorschot en, in voorkomend geval, ondertekening van het engagementcontract."
          ]
        },
        {
          "title": "3. Accounts",
          "paragraphs": [
            "Sommige functies vereisen een account. U bent verantwoordelijk voor de vertrouwelijkheid van uw inloggegevens en voor alle activiteit vanaf uw account.",
            "U verbindt zich ertoe juiste informatie te verstrekken en deze actueel te houden, met name de contact- en facturatiegegevens die voor uw reserveringen worden gebruikt."
          ]
        },
        {
          "title": "4. Aanvaardbaar gebruik",
          "paragraphs": [
            "U verbindt zich ertoe de website niet voor andere doeleinden te gebruiken, de werking ervan niet te verstoren, er geen toegang toe te verkrijgen via ongeoorloofde middelen en hem niet voor onwettige doeleinden te gebruiken.",
            "U mag de inhoud van de website, met inbegrip van artiestenfiches, foto's en biografieën, niet reproduceren of exploiteren zonder onze voorafgaande schriftelijke toestemming."
          ]
        },
        {
          "title": "5. Intellectuele eigendom",
          "paragraphs": [
            "Alle op de website gepubliceerde inhoud — merken, logo's, teksten, foto's en beeldmateriaal — is beschermd en blijft eigendom van Gazmatek, zijn partners of zijn artiesten. Buiten het louter raadplegen van de website wordt geen enkele licentie of gebruiksrecht verleend."
          ]
        },
        {
          "title": "6. Aansprakelijkheid",
          "paragraphs": [
            "Wij stellen alles in het werk om de juistheid van de informatie en de beschikbaarheid van de dienst te waarborgen, zonder de afwezigheid van fouten of onderbrekingen te kunnen garanderen.",
            "Gazmatek kan niet aansprakelijk worden gesteld voor indirecte schade die voortvloeit uit het gebruik van de website, behalve in geval van zware of opzettelijke fout."
          ]
        },
        {
          "title": "7. Contact",
          "paragraphs": [
            "Voor elke vraag over deze voorwaarden kunt u ons schrijven op contact@gazmatek.com."
          ]
        }
      ]
    },
    "privacy": {
      "title": "Privacybeleid",
      "intro": "Dit beleid legt uit hoe Gazmatek uw persoonsgegevens verzamelt, gebruikt en beschermt wanneer u onze website en bookingdiensten gebruikt, in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG).",
      "sections": [
        {
          "title": "1. Verwerkingsverantwoordelijke",
          "paragraphs": [
            "Gazmatek treedt op als verwerkingsverantwoordelijke voor de via deze website verzamelde persoonsgegevens. Voor elke vraag over uw gegevens kunt u ons contacteren op contact@gazmatek.com."
          ]
        },
        {
          "title": "2. Verzamelde gegevens",
          "paragraphs": [
            "Account- en contactgegevens: naam, e-mailadres, telefoonnummer en, in voorkomend geval, bedrijfs- en facturatiegegevens.",
            "Reserveringsgegevens: datum van het evenement, locatie, capaciteit, formaat en de details die u bij uw aanvraag meedeelt.",
            "Technische gegevens: informatie verzameld via cookies en soortgelijke technologieën om de website te beveiligen en het gebruik ervan te meten."
          ]
        },
        {
          "title": "3. Gebruik van uw gegevens",
          "paragraphs": [
            "Om uw reserveringsaanvragen te verwerken en te bevestigen en de bijbehorende contracten en betalingen te beheren.",
            "Om met u te communiceren over uw account, uw boekingen en onze diensten.",
            "Om de website te exploiteren, te beveiligen en te verbeteren en, wanneer u daarmee heeft ingestemd, het bereik ervan te meten."
          ]
        },
        {
          "title": "4. Rechtsgrond",
          "paragraphs": [
            "Wij verwerken uw gegevens om het contract of de precontractuele stappen die u vraagt uit te voeren, om onze wettelijke verplichtingen na te komen, op grond van ons gerechtvaardigd belang om het agentschap te laten functioneren, en op basis van uw toestemming wanneer die vereist is (bijvoorbeeld voor niet-essentiële cookies)."
          ]
        },
        {
          "title": "5. Delen en bewaren",
          "paragraphs": [
            "Uw gegevens kunnen worden gedeeld met de artiesten die bij uw reservering betrokken zijn en met de dienstverleners die ons helpen werken (hosting, betaling, elektronische handtekening, e-mail). Wij verkopen uw gegevens nooit.",
            "Wij bewaren uw gegevens enkel zolang als nodig is voor de hierboven beschreven doeleinden en om onze wettelijke en boekhoudkundige verplichtingen na te komen."
          ]
        },
        {
          "title": "6. Uw rechten",
          "paragraphs": [
            "Krachtens de AVG beschikt u over een recht op inzage, rectificatie en wissing van uw gegevens, een recht op beperking en bezwaar tegen de verwerking, en een recht op overdraagbaarheid. U kunt uw toestemming ook op elk moment intrekken.",
            "Om deze rechten uit te oefenen, contacteert u ons op contact@gazmatek.com. U heeft ook het recht een klacht in te dienen bij de Belgische Gegevensbeschermingsautoriteit."
          ]
        },
        {
          "title": "7. Cookies",
          "paragraphs": [
            "Wij gebruiken cookies die strikt noodzakelijk zijn voor de werking van de website en, mits uw toestemming, cookies voor het meten van het bereik en voor marketing. U kunt uw keuzes op elk moment raadplegen en wijzigen via de cookievoorkeuren op de website."
          ]
        }
      ]
    }
  }
}
